export const TankLoadModel = (load) => {
    return {
        ...load,
        loadAmount: load.loadAmount ? load.loadAmount : '',
        waste: load.waste ? load.waste : '',
    }
}

